import { AxiosPromise } from 'axios';
import { IUserMemo, IUserMemoBody } from '../models/userMemo.model';
import axios from './axiosConfig';

export const getUserMemoList = (userId: number): AxiosPromise<IUserMemo[]> => axios.get(`/api/user-memo/${userId}`);

export const postUserMemo = (body: IUserMemoBody): AxiosPromise<IUserMemo> => axios.post('/api/user-memo', body);
